import Vue from 'vue'

import defaultState from './state'

export default {
  setTransactionFields: (state, payload) => {
    if (state.transactionFieldsCurrentPage === 1) {
      state.transactionFields = payload
    } else {
      state.transactionFields.push(...payload)
    }
  },
  addTransactionField: (state, payload) => {
    const { id } = payload
    const transactionFieldToFindIndex = state.transactionFields.findIndex(el => el.id === id)
    if (transactionFieldToFindIndex !== -1) {
      state.transactionFields.splice(transactionFieldToFindIndex, 1, payload)
    } else {
      state.transactionFields.push(payload)
    }
  },
  deleteTransactionField: (state, id) => {
    const transactionFieldToFindIndex = state.transactionFields.findIndex(el => el.id === id)
    state.transactionFields.splice(transactionFieldToFindIndex, 1)
  },
  setTransactionFieldsLastPage: (state, payload) => { state.transactionFieldsLastPage = payload },
  incrementTransactionFieldsCurrentPage: (state, payload) => { state.transactionFieldsCurrentPage++ },
  setIsCallingTransactionFields: (state, payload) => { state.isTransactionFields = payload },

  setReviewFlows: (state, payload) => {
    if (state.reviewFlowsCurrentPage === 1) {
      state.reviewFlows = payload
    } else {
      state.reviewFlows.push(...payload)
    }
  },
  incrementReviewFlowsCurrentPage: state => state.reviewFlowsCurrentPage++,
  reviewFlowsLastPage: (state, payload) => {
    state.reviewFlowsLastPage = payload
  },
  setCurrentReviewFlow: (state, payload) => {
    state.currentReviewFlow = payload
  },
  addReviewFlow: (state, payload) => {
    const { id } = payload
    const reviewFlowToFindIndex = state.reviewFlows.findIndex(el => el.id === id)
    if (reviewFlowToFindIndex !== -1) {
      state.reviewFlows.splice(reviewFlowToFindIndex, 1, payload)
    } else {
      state.reviewFlows.push(payload)
    }
  },
  removeReviewFlow: (state, payload) => {
    const reviewFlowToDeleteIndex = state.reviewFlows.findIndex(el => el.id === payload)
    state.reviewFlows.splice(reviewFlowToDeleteIndex, 1)
  },
  setIsCallingReviewFlows: (state, payload) => {
    state.isCallingReviewFlows = payload
  },
  resetReviewFlows: (state) => {
    state.reviewFlows.forEach(reviewFlow => {
      reviewFlow.selected = false
      reviewFlow.steps.forEach(step => {
        step.selected = false
      })
    })
  },

  clearStoreData: state => {
    const initialState = defaultState.getDefaultState()
    Object.keys(initialState).forEach(key => {
      Vue.set(state, key, initialState[key])
    })
  }

}
